
export default {
  state: {
    subBrandListData: []
  },
  mutations: {

  },

  actions: {

  }
}